import { getLodop } from "./LodopFuncs";
import { Message } from "element-ui";
import util from '@/util/util';
var LODOP,
  P_ID = "",
  TaskID1,
  TaskID2,
  t,
  c = 0
function WaitFor(){     
  c=c+1;    
  console.log("正等待(JOB代码是"+P_ID+")打印结果："+c+"秒");
  t=setTimeout(()=>{WaitFor()},1000);    
  if (LODOP.GET_VALUE("PRINT_STATUS_OK",P_ID)) {
    clearTimeout(t);
    console.log("打印成功！");
    c=0;
    // alert("打印成功！");
  }if ((!LODOP.GET_VALUE("PRINT_STATUS_EXIST",P_ID))&&(c>0)) {
    clearTimeout(t);
    console.log("打印任务被删除！");
    c=0;
    // alert("打印任务被删除！");
  } else if (c>30){
    clearTimeout(t);
    console.log("打印超时(30秒)！");
    c=0;
    // alert("打印超过30秒没捕获到成功状态！");		
  };
};
function C_WaitFor(){     
  c=c+1;    
  console.log("正等待(JOB代码是"+P_ID+")打印结果："+c+"秒");
  t=setTimeout(()=>{C_WaitFor()},1000); 
  LODOP.On_Return_Remain=true;
  LODOP.On_Return=function(TaskID,Value){
    if (TaskID==TaskID1){
      if (Value==1){
        // (TaskID+" "+Value);
        clearTimeout(t);
        console.log("打印成功！");
        c=0;
        // alert("打印成功！");
      };
    } else 
    if (TaskID==TaskID2){
      if (Value==0){
        clearTimeout(t);
        console.log("打印任务被删除！");
        c=0;
        // alert("打印任务被删除！");
      };
    };		
  };		
  TaskID1=LODOP.GET_VALUE("PRINT_STATUS_OK",P_ID);
  TaskID2=LODOP.GET_VALUE("PRINT_STATUS_EXIST",P_ID);
  if (c>50){
    clearTimeout(t);
    console.log("打印超时(50秒)！");
    c=0;
    // alert("打印超过50秒没捕获到成功状态！");
  };
};
export function PrintWaiting(self) {
  LODOP = getLodop(self);
  console.log(LODOP);
  // let lodop=LODOP.CVERSION||'';
  // console.log(lodop)
  return new Promise((resolve, reject) => {
    if (LODOP) {
      //是否能检测到c-lodop的版本号
      if (!LODOP) {
        //c-lodop如果没启动，则不能打印
        Message.warning("请启动c-lodop服务");
        resolve({ initPrint: false });
        return;
      } else {
        resolve({ initPrint: true });
      }
      return;
    } else {
      resolve({ initPrint: false });
      return;
    }
  });
}

export function startPrinting(data) {
  console.log("打印data", data.length);
  return new Promise((resolve, reject) => {
    if (c > 0) {
      // alert("正打印中...");
      return;
    }
    LODOP.PRINT_INIT(""); //初始化在循环中
    const printName = util.getCookie('defult_print');
    if(printName){
       LODOP.SET_PRINTER_INDEX(printName);
    }
    for(let i=0;i<data.length;i++){
      LODOP.NewPage();
      loadScriptString(data[i]);
      LODOP.SET_PRINT_MODE("CUSTOM_TASK_NAME",(Math.random()*1.0e16).toString());//为每个打印单独设置任务名
      LODOP.SET_SHOW_MODE("BKIMG_IN_PREVIEW",1)      
    }
    // LODOP.PREVIEW();
    LODOP.PRINT();
		// if (LODOP.CVERSION) {
		// 	LODOP.On_Return=function(TaskID,Value){
		// 		P_ID=Value;
		// 	  console.log(P_ID,'产生新的的job代码1')
		// 		if (P_ID!="") {	c=0;C_WaitFor();};
		// 	};
    //   LODOP.PRINT()
		// 	// LODOP.PRINTA();
		// } else {
    //   P_ID=LODOP.PRINT();
		// 	// P_ID=LODOP.PRINTA();
    //   console.log(P_ID,'产生新的的job代码2')
		// 	if (P_ID!="") {	c=0;WaitFor();};
		// };
    resolve ({
      finish:true
    })
  });
}

// 动态生成script标签
function loadScriptString(code) {
  var script = document.createElement("script"); //创建一个script标签
  script.type = "text/javascript";
  try {
    //IE浏览器认为script是特殊元素,不能再访问子节点;报错;
    script.appendChild(document.createTextNode(code));
  } catch (ex) {
    script.text = code;
  }
  document.getElementsByTagName("head")[0].appendChild(script);
}
